<h1 class="page-title">View Profile</h1>
<a routerLink="/practitioner/profile/edit" class="link link--with-icon edit-link">
	<i class="icon icon--pencil"></i>
	<span class="link__text">Edit Profile</span>
</a>
	<div class="data-item">
		<div class="data-item__label label">Full Name</div>
		<div class="data-item__value">{{profile?.firstName}} {{profile?.lastName}}<span *ngIf="profile?.suffix">, {{profile?.suffix}}</span></div>
	</div>
	<div class="data-item">
		<div class="data-item__label label">SSN</div>
		<div class="data-item__value">XXX-XX-{{ profile?.ssn ? profile?.ssn.slice(-4) : 'XXXX'}}</div>
	</div>
	<div class="data-item">
		<div class="data-item__label label">Date of Birth</div>
		<div class="data-item__value">{{birthday | date: 'MM/dd/yyyy'}}</div>
	</div>
	<div class="data-item">
		<div class="data-item__label label">Address</div>
		<div class="data-item__value">
        {{profile.line1}}<br />
        {{profile.line2}}<br *ngIf="profile.line2"/>
        {{profile.city}}, {{profile.stateProvince}} {{profile.zip}}
      </div>
	</div>
	<div class="data-item">
		<div class="data-item__label label">Email</div>
		<div class="data-item__value"><a href="mailto:{{profile.email}}">{{profile.email}}</a></div>
	</div>
	<div class="data-item">
		<div class="data-item__label label">Home Phone</div>
		<div class="data-item__value"><a href="tel:{{profile.homePhone}}">{{profile.homePhone}}</a></div>
	</div>
	<div class="data-item">
		<div class="data-item__label label">Cell Phone</div>
		<div class="data-item__value"><a href="tel:{{profile.cellPhone}}">{{profile.cellPhone}}</a></div>
	</div>